// Store badges for the web menu, linking to the apps' store listings. Recreated
// as inline SVG (no external assets — the CSP blocks them anyway).

export const APP_STORE_URL = "https://apps.apple.com/app/jace-games/id6809089567";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.jacegames.app";

export const appStoreBadge = `
<svg viewBox="0 0 120 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <rect x="0.5" y="0.5" width="119" height="39" rx="7" fill="#1B1534" stroke="#1B1534"/>
  <path transform="translate(13 8) scale(0.9)" fill="#FFFFFF"
    d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.51 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
  <text x="40" y="15" fill="#E1D4FF" font-family="-apple-system,system-ui,sans-serif" font-size="7">Download on the</text>
  <text x="40" y="30" fill="#FFFFFF" font-family="-apple-system,system-ui,sans-serif" font-size="15" font-weight="600">App Store</text>
</svg>`;

export const playStoreBadge = `
<svg viewBox="0 0 120 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <rect x="0.5" y="0.5" width="119" height="39" rx="7" fill="#1B1534" stroke="#1B1534"/>
  <g transform="translate(13 10)">
    <path d="M0 0 L11 10 L0 20 Z" fill="#37D67A"/>
    <path d="M0 0 L11 10 L6 5 Z" fill="#4D7CFF" opacity="0.9"/>
    <path d="M0 20 L11 10 L6 15 Z" fill="#FFC53D" opacity="0.9"/>
  </g>
  <text x="34" y="15" fill="#E1D4FF" font-family="-apple-system,system-ui,sans-serif" font-size="7">GET IT ON</text>
  <text x="34" y="30" fill="#FFFFFF" font-family="-apple-system,system-ui,sans-serif" font-size="15" font-weight="600">Google Play</text>
</svg>`;
